$(document).ready(function () {

    $(".expandableFilterTrigger").removeClass("hide");
    $(".expandableFilter").addClass("hide");

    $(".solrShowAll").click(function () {
        $(this).parent(".expandableFilterTrigger").addClass("hide");

        $(this).closest("ul").children("li.expandableFilter").each(function () {
            if ($(this).css("display") == "none") {
                $(this).removeClass("hide");
            } else {
                $(this).addClass("hide");
            }
        });
    });

    $('.qTipMegaMenu').delegate('.sub', 'mouseover', function (event) {
        var self = $(this),
        qtip = '.qtip.ui-tooltip-new-stuller-category',
        container = $(event.liveFired),
        submenu = self.next('div'),

        // Determine whether this is a top-level menu
        isTopMenu = self.parents(qtip).length < 1;

        // If it's not a top level and we can't find a sub-menu... return
        if (isTopMenu && !submenu.length) { return false; }

        // Create the tooltip
        self.qtip({
            overwrite: false, // Make sure we only render one tooltip
            content: {
                text: submenu // Use the submenu as the qTip content
            },
            position: {
                viewport: !$("#navContent").length || $("#navContent").offset().top < $(window).scrollTop() ? $(window) : $("#navContent"),
                adjust: {
                    method: 'none shift'
                },
                my: 'left bottom',
                at: 'right bottom'
            },
            show: {
                delay: 75,
                event: event.type, // Make sure to sue the same event as above
                ready: true, // Make sure it shows on first mouseover
                solo: true
            },
            hide: {
                delay: 200,
                event: 'unfocus mouseleave',
                fixed: true // Make sure we can interact with the qTip by setting it as fixed
            },
            style: {
                classes: 'ui-tooltip-new-stuller-category',
                tip: false // We don't want a tip... it's a menu duh!
            },
            events: {
                // Toggle an active class on each menus activator
                toggle: function (event, api) {
                    api.elements.target.toggleClass('activeCatLink', event.type === 'tooltipshow');
                },
                visible: function (event, api) {
                    api.set("position.viewport", $("#navContent").offset().top < $(window).scrollTop() ? $(window) : $("#navContent"));
                }
            }
        });
    });

    $(".sectionTitle.isExpandable").click(function () {
        var sectionMenu = $(this).closest(".menuSection");

        if ($(this).siblings(".sectionLinks").is(":visible")) {
            $(sectionMenu).removeClass("clicked");
            CollapseLeftNavSection_new(sectionMenu);
        } else {
            $(sectionMenu).addClass("clicked");
            ExpandLeftNavSection_new(sectionMenu);
        }
    });

    $(window).resize(function () {
        HandleLeftNavCollapse_new();
    });

    HandleLeftNavCollapse_new();
});